import { Component, computed, inject } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { IconComponent } from '../../../ui/icon/icon.component';
import { Store } from '@ngrx/store';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { AsyncPipe, JsonPipe, NgClass } from '@angular/common';
import { selectForm, selectFormLockState } from '../../../../../store/features/forms/forms-selectors';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { LicenseKeyType } from 'src/models/ts/license-key-type.model';
import { asyncScheduler, shareReplay, take, tap } from 'rxjs';
import { AiApiService } from 'src/app/api/bizzmine/ai/ai-api.service';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-ai-button',
  standalone: true,
  templateUrl: './grid-cell-aibutton.component.html',
  styleUrl: './grid-cell-aibutton.component.scss',
  imports: [IconComponent, AsyncPipe, JsonPipe, TooltipDirective, NgClass]
})
export class GridCellAibuttonComponent extends GridCellBaseComponent<string> {
  private store$ = inject(Store);
  private aiApiService = inject(AiApiService);

  public hasAiLicense$ = this.aiApiService.hasAiLicense(LicenseKeyType.AIButton)
    .pipe(
      tap( () => {
          asyncScheduler.schedule(() => {
            ChangeDetectionService.detectChanges(this.changeDetectorRef)
          });
       }
      ),
      shareReplay(1) // Cache the result to avoid multiple emissions
    )

  public isLocked = computed(() => {
    if (this.metaData?.formId == undefined) {
      return false;
    }
    return this.store$.selectSignal(selectFormLockState(this.metaData.formId))();
  });

  public isReadonly = computed(() => {
    if (this.metaData?.formId == undefined) {
      return false;
    }
    return this.store$.selectSignal(selectForm(this.metaData.formId))()?.data?.ReadMode ?? false;
  });

  public isDisabled = computed(() => {
    return this.isReadonly() || this.isLocked();
  });

  public aiButtonCall(): void {
    this.onCellAction.emit({
      action: CellActionType.AI_BUTTON,
      data: { data: { column: this.column, data: this.data } }
    });
  }
}